export default {"src":"/_next/static/media/vital.888b4002.svg","height":30,"width":63,"blurWidth":0,"blurHeight":0};